var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SamSidebar',_vm._b({attrs:{"is-open":Boolean(_vm.component)},on:{"close":_vm.handleClose}},'SamSidebar',_vm.sidebarProps,false),[(Boolean(_vm.component))?_c(_vm.component,_vm._b({tag:"component",on:{"close":_vm.handleClose}},'component',_vm.props,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }